export default ["768px", "992px", "1280px"] // ["Tablets", "Laptops", "Desktops"]
